// extracted by mini-css-extract-plugin
export default {"link":"profile-link_link__lJlxU","active":"profile-link_active__kv-NZ"};